module.exports = __webpack_public_path__ + "static/media/GSB.3662b35b.ttf";